// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"HighlightsA_TheComp__aMDZZ"};